import React, { useEffect } from "react";
import { MDBInput, MDBBtn } from "mdb-react-ui-kit";
import {
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import { INSERT_MENUS } from "../../constants";
import { useHistory } from "react-router-dom";
import apiService from "../../variables/apiService";

var filepath =""
const AddSubsubmenu = (props) => {
  const navigate = useHistory();
  

  const [parent, setParent] = React.useState({
    name: "",
    displayname: "",
    icon: "",
    submenus: [],
  });
 
  const [child, setChild] = React.useState([
    {
      name: "",
      displayname: "",
      icon: "",
      childmenus: [
        {
          name: "",
          displayname: "",
          icon: "",
        },
      ],
    },
  ]);

  const addSubMenu = () => {
    let childObj = [...child];
    let newSubMenu = {
      name: "",
      displayname: "",
      icon: "",
      childmenus: [{
        name: "",
        displayname: "",
        icon: "",
      }],
    };

    childObj.push(newSubMenu);
    setChild(childObj);
  };
  const addSubChildMenu = (index) => {
     
    let j = child.map((item,i)=>{
      let subchildObj = child[index].childmenus ;
      if(i==index){
        let newSubMenu = {
          name: "",
          displayname: "",
          icon: "",
        }
        subchildObj.push(newSubMenu);
        return [{...item,subchildObj}];
      }
      return item;
    })
    changeSubmenuHandler();
  };
  const changeSubmenuHandler = () => { 
    let newmenus = [...child]
    let  newmenusObj= child.map((item,i)=>{
      return item;
     })  
     setChild(newmenusObj);
  }

  const changeHandler = (event) => {
    const { name, value } = event.target;
    if(name==="icon"){
      const file = event.target.files[0];
      filepath = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        setParent({ ...parent, [name]: reader.result });
      };

      reader.onerror = (error) => {
        console.log("Error: ", error);
      };
    }else{
      setParent({ ...parent, [name]: value });
    }
    
  };

  const changeHandlerChild = (event, i) => {
    const { name, value } = event.target;
    let childdata = child.map((item, index) => {
     
      if (i == index) {
        if(name==="icon"){
          var baseImg =[];
          const file = event.target.files[0];

          const reader = new FileReader();
          reader.readAsDataURL(file);
          
          reader.onload = () => {
            baseImg.push(reader.result)
          };
          reader.onerror = (error) => {
            console.log('Error: ', error);
          };
      
         
          return {...item,[name]: baseImg, imgname: file.name }
        }else{
          return { ...item, [name]: value };
        }
        
      }
      return item;
    });

    setChild(childdata);
  };
  
  const changeHandlerSubChild = (event,  i , j) => {
   
     const { name, value } = event.target;
     let new_document = [...child];
    let subchilddata = child.map((item,index) => {
     
      if (i == index) {  
        if(name==="icon"){
          var baseImg =[];
          const file = event.target.files[0];

          const reader = new FileReader();
          reader.readAsDataURL(file);
          
          reader.onload = () => {
            baseImg.push(reader.result)
          };
          reader.onerror = (error) => {
            console.log('Error: ', error);
          };
          new_document[i].childmenus[j].imgname=file.name
         
          return  new_document[i].childmenus[j][name]=baseImg; 
        }else{
          return  new_document[i].childmenus[j][name]=value; 
        }     
            
      }
      return item;
    });

    setChild(new_document)
  };

  const removeChildMenu = (i) => {
    let remainChlds = child.filter((data, index) => index != i);

    setChild(remainChlds);
  };

  const removeSubChildMenu = (event, i, j) => {
    let new_document = child;
    let subChildArr = [];
    child.map((item, index) => {
      if (i == index) {
        subChildArr = item.childmenus.filter((dta, ind) => ind != j);
        return (new_document[i].childmenus = subChildArr);
      }
      // return item;
    });

    setChild(new_document);
    changeSubmenuHandler();
  };
 
  const submitThreeLayer = () => {

    var childBase=[];
    child.map((item,index)=>{
      var subChildBase=[];
      item?.childmenus?.map((data,i)=>{
        subChildBase.push(
          {name: data.name, displayname: data.displayname, icon: data.icon[0], filename:data.imgname,})
      })
      childBase.push(
          {name: item.name, displayname: item.displayname, icon: item.icon[0], filename:item.imgname, childmenus:subChildBase})
    })
    
    let body ={
      filename: filepath,
      name:parent.name,
  icon:parent.icon,
  displayname:parent.displayname,
  submenus:childBase

    }
    

    apiService
    .postData(INSERT_MENUS, body)
    
    .then((response) => {
      
      navigate.push("/admin/user/menulist")
     // props.btnSub(false)
      
     
    })
    .catch((error) => {
      console.log("????",error);
     
    });
  
   
  
  };

  return (
    <>
      <Col
        className="mb-2"
       
        sm="12"
      >
        {/* Parent Menu */}
        <Row>
          <Col md="4" sm="12">
            <Label>Parent Icon</Label>
            <FormGroup>
              <Input
                placeholder="placeholder"
                name="icon"
                type="file"
                accept=".jpg,.jpeg,.png,.svg" 
                style={{
                  opacity: "1",
                  position: "initial",
                  border: "solid 1px #eee",
                }}
                onChange={changeHandler}
              />
            </FormGroup>
          </Col>
          <Col md="4" sm="12" className="mt-4">
            <MDBInput
              label="Menu Title"
              type="text"
              name="name"
              value={parent.name}
              onChange={changeHandler}
            />
          </Col>
          <Col md="4" sm="12" className="mt-4">
            <MDBInput
              label="Display Name "
              type="text"
              name="displayname"
              value={parent.displayname}
              onChange={changeHandler}
            />
          </Col>
        </Row>
      
        <Row>
          <Col md="10" sm="12">
            <Row>
              {child?.map((item, i) => {
              
                return (
                  <>
                  
                  <Col sm="11">
                    <Row>
                      <Col md="4" sm="12">
                        <Label>Child Icon</Label>
                        <FormGroup>
                          <Input
                            key={i}
                            placeholder="placeholder"
                            type="file"
                            accept=".jpg,.jpeg,.png,.svg" 
                            name="icon"
                            value={child.icon}
                            style={{
                              opacity: "1",
                              position: "initial",
                              border: "solid 1px #eee",
                            }}
                            onChange={(val) => changeHandlerChild(val, i)}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4" sm="12" className="mt-4">
                        <MDBInput
                          key={i}
                          label="Child Tilte"
                          type="text"
                          value={child.name}
                          name="name"
                          onChange={(val) => changeHandlerChild(val, i)}
                        />
                      </Col>
                      <Col md="4" sm="12" className="mt-4">
                        <MDBInput
                          key={i}
                          label="Display Name"
                          type="text"
                          value={child.displayname}
                          name="displayname"
                          onChange={(val) => changeHandlerChild(val, i)}
                        />
                      </Col>
                    </Row>
                    
                   
                        <Row>
                          <Col md="10" >
                            <Row>
                            {
                       
                       item?.childmenus?.map((data, index) => {
                        
                         return (
                          <>
                            <Col md="11" >
                              <Row>
                          <Col md="4" sm="12">
                            <Label>SubChild Icon</Label>
                            <FormGroup>
                              <Input
                                key={i}
                                placeholder="placeholder"
                                type="file"
                                accept=".jpg,.jpeg,.png,.svg" 
                                name="icon"
                               
                                style={{
                                  opacity: "1",
                                  position: "initial",
                                  border: "solid 1px #eee",
                                }}
                                onChange={(val) => changeHandlerSubChild(val, i,index)}
                              />
                            </FormGroup>
                          </Col>
                          <Col md="4" sm="12" className="mt-4">
                            <MDBInput
                              key={i}
                              label="SubChild Tilte"
                              type="text"
                              value={data.name}
                              name="name"
                              onChange={(val) => changeHandlerSubChild(val, i,index)}
                            />
                          </Col>
                          <Col md="4" sm="12" className="mt-4">
                            <MDBInput
                              key={i}
                              label="Display Name"
                              type="text"
                              value={data.displayname}
                              name="displayname"
                              onChange={(val) => changeHandlerSubChild(val, i, index)}
                            />
                          </Col>
                        </Row>
                              </Col>
                              <Col md="1">
                                        <Button
                                          className="btn btn-icon btn-remove-style  mt-4"
                                          onClick={(val) =>
                                            removeSubChildMenu(val, i, index)
                                          }
                                        >
                                          <i class="fa fa-minus" aria-hidden="true"></i>
                                        </Button>
                                      </Col>
                          </>
                            
                               );
                              })}
                            </Row>
                       
                        </Col>
                        <Col md="2" sm="12">
                        <Button
                          className="btn btn-icon btn-add-style  mt-4"
                          onClick={()=>addSubChildMenu(i)}
                        >
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </Button>
                      </Col>
                      </Row>
                     
                  </Col>
                  <Col md="1">
                          <Button
                            className="btn btn-icon btn-remove-style mt-4"
                            onClick={() => removeChildMenu(i)}
                          >
                            <i class="fa fa-minus" aria-hidden="true"></i>
                          </Button>
                        </Col>
                  </>

                );
              })}
            </Row>
          </Col>
          <Col md="2" sm="12">
            <Button
              className="btn btn-icon btn-add-style  mt-4"
              onClick={addSubMenu}
            ><i class="fa fa-plus" aria-hidden="true"></i>
            </Button>
          </Col>
        </Row>

        <Col md="12" sm="12">
        <Button color="primary " className="btn btn-icon" type="button" onClick={submitThreeLayer}>
        <i className="tim-icons icon-double-right" />
          </Button>
        </Col>
      </Col>
    </>
  );
};

export default AddSubsubmenu;
